// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UploadResumeModal_modalContent__2_K1t","tableWrapper":"UploadResumeModal_tableWrapper__27fuD"};